"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountUnitToJSON = exports.AmountUnitFromJSONTyped = exports.AmountUnitFromJSON = exports.AmountUnit = void 0;
/**
 * This signifies what the number in the \'amount\' field is.
 * @export
 * @enum {string}
 */
var AmountUnit;
(function (AmountUnit) {
    AmountUnit["FIAT"] = "FIAT";
    AmountUnit["VARIABLE"] = "VARIABLE";
    AmountUnit["FIXED"] = "FIXED";
})(AmountUnit = exports.AmountUnit || (exports.AmountUnit = {}));
function AmountUnitFromJSON(json) {
    return AmountUnitFromJSONTyped(json, false);
}
exports.AmountUnitFromJSON = AmountUnitFromJSON;
function AmountUnitFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AmountUnitFromJSONTyped = AmountUnitFromJSONTyped;
function AmountUnitToJSON(value) {
    return value;
}
exports.AmountUnitToJSON = AmountUnitToJSON;
